import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { ReactNode } from 'react';
import styles from './IconFeatureList.module.scss';
export interface IconFeatureListItem {
  /**
   * Decorative: one or more inline SVG icons (aria-hidden as a group). An
   * SVG drawn at 1em follows the slot's size.
   */
  icon?: ReactNode;
  title: ReactNode;
  /** The item's copy: a paragraph, or plain text. */
  body: ReactNode;
}
export type IconFeatureListTitleAs = 'h3' | 'h4';
export type IconFeatureListColumns = 2 | 3 | 4;
export interface IconFeatureListProps {
  items: readonly IconFeatureListItem[];
  /** The title's heading level: the pages that adopt it use both. */
  titleAs: IconFeatureListTitleAs;
  /** Columns from `lg`: one column below `md`, two from `md`. */
  columns?: IconFeatureListColumns;
}

// Two columns is the md layout already; three and four widen it from lg.
const COLUMN_CLASS_NAMES: Record<IconFeatureListColumns, string | undefined> = {
  2: undefined,
  3: styles['helios-icon-feature-list--columns-3'],
  4: styles['helios-icon-feature-list--columns-4']
};

/**
 * A grid of features, each an icon, a title and a line of copy (Phase 5 PR
 * 5.0; the legacy `.icon-wrap` blocks on Try College, Sacramento and
 * Forever21). A list, so a screen reader announces the count; the icon slot
 * is aria-hidden and sized from the card title role, in the surface's
 * accent; the title is the card title role, the copy body text in the
 * secondary text. Incubating: no page adopts it in 5.0.
 */
function IconFeatureList(t0) {
  const $ = _c(10);
  const {
    items,
    titleAs: Title,
    columns: t1
  } = t0;
  const columns = t1 === undefined ? 3 : t1;
  if (items.length === 0) {
    return null;
  }
  const t2 = COLUMN_CLASS_NAMES[columns];
  let t3;
  if ($[0] !== t2) {
    t3 = classNames(styles["helios-icon-feature-list"], t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== Title || $[3] !== items) {
    let t5;
    if ($[5] !== Title) {
      t5 = (item, index) => <li className={styles["helios-icon-feature-list__item"]} key={index}>{item.icon ? <span aria-hidden="true" className={styles["helios-icon-feature-list__icon"]}>{item.icon}</span> : null}<Title className={styles["helios-icon-feature-list__title"]}>{item.title}</Title><div className={styles["helios-icon-feature-list__body"]}>{item.body}</div></li>;
      $[5] = Title;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = items.map(t5);
    $[2] = Title;
    $[3] = items;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <ul className={t3} data-helios-icon-feature-list="">{t4}</ul>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
export default IconFeatureList;